export default __webpack_public_path__ + "static/media/resumev3.6662ce1a.pdf";